'use es6';

import { Component } from 'react';
import { getContentModelId, getTemplatePath, getPreviewKey } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getTemplateLabel, getHasTemplate, getIsRestorableTemplate } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import ContentRoutes from 'ContentUtils/Routes';
import ForceTemplateSwapModal from 'ContentEditorUI/components/modals/ForceTemplateSwapModal';
import TemplateSelectModal from 'ContentEditorUI/components/modals/TemplateSelectModal';
import { getHasModulesInFlexColumn } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { connect } from 'react-redux';
import { bindAll } from 'underscore';
import { fetchTemplateInfo, handleRestoreMissingTemplate } from 'ContentEditorUI/redux/actions/templateInfoActions';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  isMissingTemplate: !getHasTemplate(state),
  messageKey: getTemplatePath(state) ? getTemplateLabel(state) ? 'deletedTemplateMessage' : 'deletedTemplateNoLabelMessage' : 'noTemplateMessage',
  templatePath: getTemplatePath(state),
  contentId: getContentModelId(state),
  hasModulesInFlexColumn: getHasModulesInFlexColumn(state),
  shouldShowRestore: getIsRestorableTemplate(state),
  previewKey: getPreviewKey(state)
});

/**
 * @param {Object} props
 * @param {string} props.cancelRedirectUrl (conditionally required - required when contentType is 'email')
 * @param {React.ReactNode} [props.children] (optional)
 * @param {number} props.contentId (required)
 * @param {string} props.contentType (required)
 * @param {Function} props.fetchTemplateInfo (required)
 * @param {Function} props.handleRestoreMissingTemplate (required)
 * @param {boolean} props.hasModulesInFlexColumn (required)
 * @param {boolean} [props.isCustomTemplateWithFlexArea] (optional)
 * @param {boolean} props.isMissingTemplate (required)
 * @param {string} props.messageKey (required)
 * @param {string} [props.previewKey] (optional)
 * @param {boolean} props.shouldShowRestore (required)
 * @param {string} props.templatePath (required)
 */
class TemplateExistenceCheckContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForceTemplateSwampModal: props.isMissingTemplate,
      showTemplateSelectModal: false
    };
    bindAll(this, 'onConfirm', 'closeTemplateSelectModal');
  }
  componentDidMount() {
    if (this.props.isMissingTemplate) {
      this.props.fetchTemplateInfo(this.props.templatePath);
    }
  }
  onConfirm() {
    this.setState({
      showForceTemplateSwampModal: false
    });
    const {
      contentType,
      contentId
    } = this.props;
    if (contentType === 'email') {
      this.setState({
        showTemplateSelectModal: true
      });
    } else {
      window.location.href = ContentRoutes.templateSwap(contentType, contentId);
    }
  }
  closeTemplateSelectModal() {
    const {
      cancelRedirectUrl
    } = this.props;
    window.location = cancelRedirectUrl;
  }
  render() {
    const {
      messageKey,
      hasModulesInFlexColumn,
      children,
      isCustomTemplateWithFlexArea,
      shouldShowRestore,
      contentType,
      contentId,
      previewKey
    } = this.props;
    const {
      showForceTemplateSwampModal,
      showTemplateSelectModal
    } = this.state;
    if (showForceTemplateSwampModal) {
      return /*#__PURE__*/_jsx(ForceTemplateSwapModal, {
        onConfirm: this.onConfirm,
        messageKey: messageKey,
        hasModulesInFlexColumn: hasModulesInFlexColumn,
        shouldShowRestore: shouldShowRestore,
        onRestore: this.props.handleRestoreMissingTemplate,
        hasDndArea: isCustomTemplateWithFlexArea
      });
    }
    if (showTemplateSelectModal) {
      return /*#__PURE__*/_jsx(TemplateSelectModal, {
        contentType: contentType,
        contentId: contentId,
        onClose: this.closeTemplateSelectModal,
        previewKey: previewKey,
        hasDndArea: isCustomTemplateWithFlexArea
      });
    }
    if (children) {
      return children;
    }
    return null;
  }
}
export default connect(mapStateToProps, {
  handleRestoreMissingTemplate,
  fetchTemplateInfo
})(TemplateExistenceCheckContainer);